import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input: React.FC<InputProps> = ({ className = '', ...props }) => {
  return (
    <input
      className={`
        p-3 lg:p-5 bg-black/40 text-theme pixel-border text-[9px] lg:text-sm 
        font-bold uppercase text-center tracking-widest focus:outline-none 
        focus:bg-theme/20 placeholder-gray-700
        ${className}
      `}
      {...props}
    />
  );
};
